var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('branded-email-confirmation',{staticClass:"q-mt-xl",attrs:{"brand":_vm.brand,"brand-icon":_vm.brandData.logo,"back-page":_vm.brandRouteName(_vm.brand, 'Login')},on:{"send-confirmation-email":_vm.sendConfirmationEmail}})}
var staticRenderFns = []

export { render, staticRenderFns }